import $ from "jquery";
import "slick-carousel";
import { FireComponent } from "@component";

export class PeopleSlider extends FireComponent {
  constructor(id) {
    super(id);
  }

  get elements() {
    return {
      $prev: this.findElement("prev"),
      $next: this.findElement("next"),
      $full: this.findElement("slider-full"),
      $right: this.findElement("slider-right"),
      $left: this.findElement("slider-left"),
      $slides: this.findElement("center-slide"),
      $sideSlides: this.findElement("side-slide"),
    };
  }

  _initSlider() {
    var $sliderPager = $(".slider-pager");

    this.elements.$full.on(
      "init reInit afterChange",
      function (event, slick, currentSlide, nextSlide) {
        var i = (currentSlide ? currentSlide : 0) + 1;
        $sliderPager.html(
          `<span class="text-14 leading-5  tracking-wider hello-world font-bold text-gray-700 md:tracking-widest md:text-20 md:mx-8"><span class="text-secondary-500 transition duration-500 ease-in">0${i}</span>&nbsp;&nbsp;&nbsp;<span class="text-16 md:text-22">/</span>&nbsp;&nbsp;&nbsp;0${slick.slideCount}</span>`
        );
      }
    );

    this.elements.$full.slick({
      infinite: true,
      slidesToShow: 1,
      slidesToScroll: 1,
      dots: false,
      arrows: true,
      fade: true,
      prevArrow: this.elements.$prev,
      nextArrow: this.elements.$next,
      autoplay: this.elements.$full.data("autoplay")
        ? this.elements.$full.data("autoplay")
        : false,
      autoplaySpeed: this.elements.$full.data("speed")
        ? this.elements.$full.data("speed")
        : 7000,
      asNavFor: $(".people-slider__slider"),
      responsive: [
        {
          breakpoint: 767,
          settings: {
            fade: false,
          },
        },
      ],
    });

    this.elements.$left.slick({
      infinite: true,
      slidesToShow: 2,
      slidesToScroll: 1,
      dots: false,
      arrows: false,
      draggable: false,
      responsive: [
        {
          breakpoint: 1440,
          settings: {
            slidesToShow: 1,
          },
        },
      ],
    });

    this.elements.$right.slick({
      infinite: true,
      slidesToShow: 2,
      slidesToScroll: 1,
      arrows: false,
      dots: false,
      draggable: false,
      responsive: [
        {
          breakpoint: 1440,
          settings: {
            slidesToShow: 1,
          },
        },
      ],
    });

    var stHeight = 0;
    this.elements.$sideSlides.each(function () {
      var h = $(this).height();
      if (h > stHeight) {
        stHeight = h;
      }
    });
    this.elements.$sideSlides.css("height", stHeight + "px");
  }

  _initEventListeners() {
    this.elements.$right.on("click", ".slick-slide", (e) => {
      var $targetIndex = parseInt(
        $(e.currentTarget).attr("data-slick-index")
      );
      this.elements.$full.slick("slickGoTo", $targetIndex + 1);
    });

    this.elements.$left.on("click", ".slick-slide", (e) => {
      var $targetIndex = parseInt(
          $(e.currentTarget).attr("data-slick-index")
        ),
        $total = parseInt(this.elements.$left.attr("data-length"));

      if ($(window).innerWidth() >= 1440) {
        if ($targetIndex === 0) {
          this.elements.$full.slick("slickGoTo", $total - 2);
        } else {
          this.elements.$full.slick("slickGoTo", $targetIndex - 2);
        }
      } else {
        this.elements.$full.slick("slickGoTo", $targetIndex - 1);
      }
    });
  }

  init() {
    if (!this.componentExists) return;
    this._initSlider();
    this._initEventListeners();
  }
}
